import { ReactNode } from "react";
// oxlint-disable-next-line no-restricted-imports -- ViewTable owns the GridTable implementation.
import { GridTableRow } from "@design-system/Tables/GridTable/GridTable";
import styles from "./ViewTable.module.scss";

interface ViewTableFullWidthRowProps {
    content: ReactNode;
    index: number;
    measureElement: (node: HTMLElement | null) => void;
}

// A row whose content spans every grid column instead of rendering one cell
// per visible column. Used for group-level affordances (load-more and
// error rows) that don't map onto the table's columns. Display-only: not
// clickable, not draggable. Height is content-sized; `measureElement` +
// `data-index` let the virtualizer track that instead of the density height.
export const ViewTableFullWidthRow = ({
    content,
    index,
    measureElement,
}: ViewTableFullWidthRowProps) => (
    <GridTableRow setNodeRef={measureElement} data-index={index}>
        <div className={styles.fullWidthCell}>{content}</div>
    </GridTableRow>
);
